(() => {
  "use strict";
  const DEBUG = localStorage.getItem("SWYM_CUSTOM_DEBUG") === "true";
  const DEFAULT_WISHLIST_NAME = "My Greyson Wishlist"
  // Initialization and event binding
  const onSwymLoadCallback = async (swat) => {
    if (swat) {
      // save a references
      window.swat = swat;
      window.swymDeleteAllWishlists = deleteAllLists;
      window.swymDeleteAllWishlistsExcept = deleteAllListsExcept;
      // initialize the list of current wishlists from SWYM, and set our default list.
      // if we cannot find our explicit default wishlist by name, create it and set that as the default.
      await initializeWishlists();
      // set up event listeners for when items in the wishlist are added to cart, or items are removed from the wishlist.
      setEventListeners();
      // call the initializing function on all present wishlist buttons.
      initializeCustomButtons();
    }
  };

  // run the init function of any custom wishlist button
  const initializeCustomButtons = () => {
    // collect all custom buttons on the page and start them up.
    const wishlistButtons = document.querySelectorAll(`swym-custom-add-to-wishlist`);
    if (wishlistButtons) {
      wishlistButtons.forEach((button) => {
        if (typeof button.init === "function") {
          button.init();
        }
      });
    }
  };

  // Initialization and management of wishlist data
  const initializeWishlists = async () => {
    try {
      // grab lists from SWYM
      let lists = await fetchLists();
      // assign the array of lists to our "global list"
      window.swymWishlists = lists.length > 0 ? await fetchListDetails(lists) : [];
      // for good measure right now, delete any list that is not the default wishlist name
      await deleteAllListsExcept(DEFAULT_WISHLIST_NAME);
      // look for the default wishlsit name and make it the default.
      window.swymDefaultWishlist = findWishlistByName(DEFAULT_WISHLIST_NAME);
      // Check if the default list name exists, and create if not found
      if (Object.keys(window.swymDefaultWishlist).length === 0) {
        if (DEBUG) console.log(`swym-custom.js: ${DEFAULT_WISHLIST_NAME} not found, creating new...`);
        await createAndSetDefaultWishlist(DEFAULT_WISHLIST_NAME);
      }
      if (DEBUG) console.log("swym-custom.js: all wishlists: ", window.swymWishlists);
      if (DEBUG) console.log("swym-custom.js: Default wishlist: ", window.swymDefaultWishlist);
    } catch (error) {
      console.error("Failed to initialize wishlists", error);
    }
  };

  // Search for the given list name, return that list if possible.
  const findWishlistByName = (desiredListName) => {
    return window.swymWishlists.find((list) => list.list?.lname === desiredListName) || {};
  };

  // Function to create and set the sent parameter as the default
  const createAndSetDefaultWishlist = async (newListName) => {
    const newListConfig = { lname: newListName };
    try {
      const newList = await createList(newListConfig);
      if (DEBUG) console.log("swym-custom.js: createAndSetDefaultWishlist", newList);
      const newListDetails = await fetchListDetails([newList]);
      window.swymWishlists.push(newListDetails[0]);
      window.swymDefaultWishlist = newListDetails[0];
    } catch (error) {
      console.error("Error creating default list", error);
    }
  };

  // Create a new list
  const createList = (listConfig) => {
    return new Promise((resolve, reject) => {
      swat.createList(listConfig, resolve, reject);
    });
  };

  // Fetch all wishlist "shells"
  const fetchLists = () => {
    return new Promise((resolve, reject) => {
      swat.fetchLists({ callbackFn: resolve, errorFn: reject });
    });
  };

  // Fetch detailed data for each list
  const fetchListDetails = (lists) => {
    const detailsPromises = lists.map((list) => {
      return new Promise((resolve, reject) => {
        swat.fetchListDetails(list?.lid, resolve, reject);
      });
    });
    return Promise.all(detailsPromises);
  };

  // Event listeners for wishlist interaction
  const setEventListeners = () => {
    window.swat.evtLayer.addEventListener("sw:addedtocart", handleAddedToCart);
    window.swat.evtLayer.addEventListener("sw:removedfromwishlist", handleRemovedFromWishlist);
    window.swat.evtLayer.addEventListener("sw:addedtowishlist", handleAddedToWishlist);
  };

  // Handle adding wishlist item to cart
  const handleAddedToCart = (addedItems) => {
    if (DEBUG) console.log("swym-custom.js: Added item(s) to cart from wishlist", addedItems);
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.refresh();
      cartDrawer.open();
    }
  };

  // Handle removing item from wishlist
  const handleRemovedFromWishlist = async (removeFromWishlistEvent) => {
    await initializeWishlists();
    const removedItemId = removeFromWishlistEvent.detail?.d?.empi;
    if (!removedItemId) return;
    const wishlistButtons = document.querySelectorAll(`swym-custom-add-to-wishlist`);
    if (wishlistButtons) {
      wishlistButtons.forEach((button) => {
        if (typeof button.refreshComponentState === "function") {
          button.refreshComponentState();
        }
      });
    }
  };

  // Handle adding item to wishlist
  const handleAddedToWishlist = async (addedToWishlistEvent) => {
    if (DEBUG) console.log("swym-custom.js: Added item(s) to the wishlist", addedToWishlistEvent);
    await initializeWishlists();
    const addedItemId = addedToWishlistEvent.detail?.d?.empi;
    if (!addedItemId) return;
    const wishlistButtons = document.querySelectorAll(`swym-custom-add-to-wishlist`);
    if (wishlistButtons) {
      wishlistButtons.forEach((button) => {
        if (typeof button.refreshComponentState === "function") {
          button.refreshComponentState();
        }
      });
    }
  };

  // in case of emergency or fresh start a quick function to delete all wishlists of the current user.
  const deleteAllLists = async () => {
    if (DEBUG) console.log(`swym-custom.js: Starting deletion of all wishlists: `, window.swymWishlists);
    window.swymWishlists.forEach((wishlist) => {
      swat.deleteList(wishlist.list?.lid, successData => {
        console.log("List deleted successfully: ", successData);
      }, errorData => {
        console.error("Failed to delete list: ", errorData);
      });
    });
  };

  // in case of emergency or fresh start a quick function to delete all wishlists of the current user.
  const deleteAllListsExcept = async (lname) => {
    if (DEBUG) console.log(`swym-custom.js: Starting deletion of all wishlists except ${lname}: `, window.swymWishlists);
    window.swymWishlists.forEach((wishlist) => {
      if (wishlist.list?.lname !== lname){
        swat.deleteList(wishlist.list?.lid, successData => {
          console.log("List deleted successfully: ", successData);
        }, errorData => {
          console.error("Failed to delete list: ", errorData);
        });
      }
    });
  };

  // Register the initial load callback
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwymLoadCallback);
})();
